<template>
	<div class="navigation_stories" ref="nav_container">
		<div class="nav_content" v-if="$i18n.messages[$i18n.locale]">
			<div class="d-flex"><a href="#" class="logo"></a><a class="close-btn-nav" @click="closeNav()">
        <font-awesome-icon icon="times" class="iconos-redes" />
      </a></div>
			<ul class="mt-5">
				<li class="back">
					<RouterLink :to="{ name: 'list' }">
					<font-awesome-icon v-if="$route.name == 'story'" icon="arrow-left" class="iconos" /> {{ $i18n.messages[$i18n.locale].historia_principal }}
				</RouterLink></li>
				<li class="item-nav" :key="item.url" v-for="item in $i18n.messages[$i18n.locale].indice">
					<RouterLink :to="{ name: 'story', params: { url: item.url } }">
						{{ item.titulo }}
					</RouterLink>
				</li>
				<li class="creditos-link">
					<RouterLink :to="{ name: 'list', query: {creditos: 'show'}}">
					{{ $i18n.messages[$i18n.locale].creditos }}
				</RouterLink>
			</li>
			</ul>
			<ul class="languages-menu" v-if="$route.name == 'list'">
				<li><RouterLink :to="{ name: 'list', params: { locale: 'es' }  }">
					Es
				</RouterLink></li>
				<li><RouterLink :to="{ name: 'list', params: { locale: 'en' }  }">
					En
				</RouterLink></li>
				<li><RouterLink :to="{ name: 'list', params: { locale: 'pt' }  }">
					Pt
				</RouterLink></li>
			</ul>
			<ul class="languages-menu" v-if="$route.name == 'story'">
				<li><RouterLink :to="{ name: 'story', params: { locale: 'es', url: `${$route.params.url}` }}">
					Es
				</RouterLink></li>
				<li><RouterLink :to="{ name: 'story', params: { locale: 'en', url: `${$route.params.url}` }}">
					En
				</RouterLink></li>
				<li><RouterLink :to="{ name: 'story', params: { locale: 'pt', url: `${$route.params.url}` }}">
					Pt
				</RouterLink></li>
			</ul>
			<ul class="podcast">
				<li><a target="_blank" href="https://soundcloud.com/ojopublico/visiones-del-coronavirus-en-la-amazonia-indigena"><span>Podcast</span> <font-awesome-icon :icon="['fab', 'soundcloud']" class="iconos-redes" /></a></li>
			</ul>

			<div class="d-flex align-self-center justify-content-center text-center">
				<div>
					<ShareNetwork
					network="facebook"
					title="Visiones del coronavirus"
					description="Memoria indígena de la pandemia en la Amazonía: ocho artistas y 15 periodistas de Perú, Brasil, Colombia y Ecuador retratan el impacto en sus comunidades."
					quote="Memoria indígena de la pandemia en la Amazonía: ocho artistas y 15 periodistas de Perú, Brasil, Colombia y Ecuador retratan el impacto en sus comunidades."
					url="https://ojo-publico.com/especiales/visiones-del-coronavirus/"
				>
					<font-awesome-icon :icon="['fab', 'facebook']" class="iconos-redes" />
			</ShareNetwork></div>

				<div>
					<ShareNetwork
						network="twitter"
						url="https://ojo-publico.com/especiales/visiones-del-coronavirus/"
						title="Visiones del coronavirus"
						description="Visiones del coronavirus: memoria indígena de la pandemia en la Amazonía. Un proyecto de @Ojo_publico https://ojo-publico.com/especiales/visiones-del-coronavirus/"
						quote="Visiones del coronavirus: memoria indígena de la pandemia en la Amazonía. Un proyecto de @Ojo_publico https://ojo-publico.com/especiales/visiones-del-coronavirus/"
					>
						<font-awesome-icon :icon="['fab', 'twitter']" class="iconos-redes" />
					</ShareNetwork>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import utils from '@/mixins/utils'

export default {
	name: 'Navigation',
	mixins: [utils],
	methods: {
		activeLink(url) {
			if(url == this.$route.params.url){
				return `active-chapter`
			}

			return ``
		},
		closeNav() {
			this.$refs[`nav_container`].classList.remove('active_nav')
			document.querySelector(`.topbar-especial`).classList.remove('active_nav')
		}
	}
}
</script>
